module.exports = __webpack_public_path__ + "static/media/logo.51f61ac8.svg";